<template>
  <div class="filter-item" ref="main">
    <div class="filter-item-header">
      <span class="state">{{this.showFilter.sectionKey}}.{{this.showFilter.parameterKey}}</span>
      <span style="padding: 6px">
        <select v-model="select_state" class="select" :style="`color: ${$vuetify.theme.themes.light.primary}`" @change="updateLeadFilter($event)">
            <option v-for="(item, index) in states" :key="index">{{item.text}}</option>
        </select>
        <span class="tag" :style="`color: ${$vuetify.theme.themes.light.primary}`"></span>
        <v-tooltip top>
          <template v-slot:activator="{ on,attrs }">
            <v-icon v-bind="attrs" v-on="on" size="20" class="operation-btn" @click="addFile">input</v-icon>
            <input type="file" id="refFile" ref="refFile" style="display: none" v-on:change="fileLoad" accept="text/plain">
          </template>
          <span>Import</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on,attrs }">
            <v-icon v-bind="attrs" v-on="on" size="20" class="operation-btn" @click="exportFile">logout</v-icon>
          </template>
          <span>Export</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on,attrs }">
            <v-icon v-bind="attrs" v-on="on" size="20" class="operation-btn-delete" @click="deleteFileCard">delete_forever</v-icon>
          </template>
          <span>Delete</span>
          <sure-delete-dialog :dialog="dialog" :deleteItem="deleteItem" @deleteItemSuccessful="deleteItemSuccessful" :tips="tips"></sure-delete-dialog>
        </v-tooltip>
      </span>
    </div>
    <div class="filter-item-content">
      <input type="text" :value="select_label" class="total-items" readonly @click="searchItemsDetail"/>
      <span v-if="showAdd" class="add-icons" :style="`backgroundColor: ${$vuetify.theme.themes.light.primary}`" @click="dialog.visible = true">+</span>
      <span v-if="deleteById" class="add-icons-delete" @click="deleteFilterById">-</span>
      <sure-delete-dialog :dialog="dialog" :deleteId="deleteId" @deleteSuccessful="deleteSuccessful" :tips="tips"></sure-delete-dialog>
    </div>
    <div class="contentItems" v-if="searchItems">
      <div class="searchItems" >
        <input type="text" class="content-input" v-model="parameter" v-on:input="showItemsDetail"/>
        <input type="text" readonly="readonly" class="content-searching" value="Searching..." v-if="searching"/>
        <ul v-if="showResult" class="item-tabs">
          <li v-for="(item,index) in resultItems" :key="index" class="nav-item" @click="chooseItem($event)">{{item.parameterValue}}</li>
        </ul>
      </div>
    </div>

    <add-filter-dialog :dialog="dialog" @getParameterValue="getParameterValue" ref="addOneItem"></add-filter-dialog>
    <add-successful-dialog :dialog="dialog"></add-successful-dialog>
    <add-failure-dialog :dialog="dialog" :failureMessage="failureMessage"></add-failure-dialog>
    <import-successful-dialog :dialog="dialog" :successfulMessage="successfulMessage"></import-successful-dialog>
    <v-dialog
      v-model="isLoading"
      overlay-color="#2296F3"
      overlay-opacity="0.6"
      persistent
      width="300"
    >
      <v-card>
        <v-card-text style="height: 36px !important">
          Please stand by
          <v-progress-linear
            indeterminate
            color="#009688"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { LFSConfigurationApi } from '@/api/pandaria'
import AddFilterDialog from '@/components/panda/setting/dialog/AddFilterDialog.vue'
import AddSuccessfulDialog from '@/components/panda/setting/dialog/AddSuccessfulDialog.vue'
import AddFailureDialog from '@/components/panda/setting/dialog/AddFailureDialog.vue'
import SureDeleteDialog from '@/components/panda/setting/dialog/SureDeleteDialog.vue'
import ImportSuccessfulDialog from '@/components/panda/setting/dialog/ImportSuccessfulDialog'
import { Tool, DataType } from '@/util/index'
const tool = new Tool()
export default {
  name: 'FilterCard',
  components: {
    AddFilterDialog,
    AddSuccessfulDialog,
    AddFailureDialog,
    SureDeleteDialog,
    ImportSuccessfulDialog
  },
  props: ['showFilter'],
  data: () => ({
    items: [],
    states: DataType.states,
    select_state: 'EQUAL',
    select_label: '',
    dialog: {
      visible: false,
      showProgress: false,
      successful: false,
      failure: false,
      showDelete: false,
      inputSuccessful: false
    },
    parameterValue: 0,
    failureMessage: '',
    parameter: '',
    searchItems: false,
    resultItems: [],
    showResult: false,
    deleteById: false,
    showAdd: true,
    deleteId: 0,
    deleteItem: {},
    fileArr: [],
    successfulMessage: '',
    tips: '',
    isLoading: false,
    searching: false
  }),
  mounted () {
    document.addEventListener('click', this.bodyCloseMenus)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.bodyCloseMenus)
  },
  watch: {
    showFilter (val) {
      this.select_label = 'TOTAL ' + val.count + ' ITEMS'
    }
  },
  methods: {
    deleteSuccessful () {
      this.select_label = 'TOTAL ' + (this.showFilter.count - 1) + ' ITEMS'
      this.showAdd = true
      this.deleteById = false
    },
    deleteItemSuccessful () {
      this.$emit('deleteCard', this.deleteItem)
    },
    bodyCloseMenus (e) {
      const $this = this
      if (this.$refs.main && !this.$refs.main.contains(e.target)) {
        if ($this.searchItems === true) {
          $this.searchItems = false
          $this.parameter = ''
          $this.resultItems = []
        }
      }
    },
    getParameterValue (data) {
      this.parameterValue = data
      this.addFilter()
    },
    addFilter () {
      const $this = this
      const input = {
        companyId: 1,
        channelId: $this.showFilter.channelId,
        portfolioId: $this.showFilter.portfolioId,
        type: $this.showFilter.type,
        sectionKey: $this.showFilter.sectionKey,
        parameterKey: $this.showFilter.parameterKey,
        parameterValue: $this.parameterValue,
        operator: $this.showFilter.operator
      }
      LFSConfigurationApi.addLeadFilterParameter(input, function () {
        $this.dialog.showProgress = false
        $this.dialog.visible = false
        $this.dialog.successful = true
        $this.select_label = 'TOTAL ' + ($this.showFilter.count + 1) + ' ITEMS'
        $this.showFilter.count = $this.showFilter.count + 1
        $this.$refs.addOneItem.parameterValue = ''
      }, function (result) {
        $this.dialog.showProgress = false
        $this.dialog.visible = false
        $this.failureMessage = result.message
        $this.dialog.failure = true
        $this.$refs.addOneItem.parameterValue = ''
      })
    },
    updateLeadFilter (e) {
      const operatorText = this.states.find(ele => ele.value === this.showFilter.operator).text
      if (this.showFilter.count === 0) {
        this.showFilter.operator = this.states.find(ele => ele.text === this.select_state).value
      } else {
        if (e.target.value === operatorText) {
        } else {
          const $this = this
          const currentOperator = this.states.find(ele => ele.text === e.target.value).value
          const input = {
            companyId: 1,
            channelId: $this.showFilter.channelId,
            portfolioId: $this.showFilter.portfolioId,
            type: $this.showFilter.type,
            sectionKey: $this.showFilter.sectionKey,
            parameterKey: $this.showFilter.parameterKey,
            original: $this.showFilter.operator,
            current: currentOperator
          }
          $this.$emit('updateLeadFilterState', input, this.showFilter)
        }
      }
    },
    searchItemsDetail () {
      if (this.searchItems === true) {
        this.searchItems = false
      } else {
        this.searching = true
        this.searchItems = true
        const $this = this
        const input = $this.prepareParameter()
        input.parameterValue = ''
        LFSConfigurationApi.detailLeadFilterParameter(input, function (result) {
          if (tool.isEmpty(result)) {
            $this.showResult = true
            $this.resultItems = [{ parameterValue: 'Search results are empty' }]
            $this.searching = false
          } else {
            if (result instanceof Array) {
              $this.showResult = true
              $this.resultItems = result
              $this.searching = false
            } else {
              $this.showResult = true
              $this.resultItems = [{ parameterValue: 'Total ' + result + ' items' }]
              $this.searching = false
            }
          }
        })
      }
    },
    showItemsDetail () {
      const $this = this
      $this.searching = true
      const input = $this.prepareParameter()
      input.parameterValue = $this.parameter
      LFSConfigurationApi.detailLeadFilterParameter(input, function (result) {
        if (tool.isEmpty(result)) {
          $this.showResult = true
          $this.resultItems = [{ parameterValue: 'Search results are empty' }]
          $this.searching = false
        } else {
          if (result instanceof Array) {
            $this.showResult = true
            $this.resultItems = result
            $this.searching = false
          } else {
            $this.showResult = true
            $this.resultItems = [{ parameterValue: 'Total ' + result + ' items' }]
            $this.searching = false
          }
        }
      })
    },
    chooseItem (e) {
      const chooseId = this.resultItems.find(ele => ele.parameterValue === e.target.innerText).id
      this.showAdd = false
      this.deleteById = true
      this.searchItems = false
      this.deleteId = chooseId
      this.select_label = e.target.innerText
    },
    deleteFilterById () {
      this.tips = 'Are you sure to DELETE the value?'
      this.dialog.showDelete = true
    },
    deleteFileCard () {
      this.deleteItem = this.showFilter
      this.tips = 'Are you sure to DELETE ALL values?'
      if (this.showFilter.count === 0) {
        this.$emit('deleteCard', this.deleteItem)
      } else {
        this.dialog.showDelete = true
      }
    },
    addFile () {
      this.$refs.refFile.dispatchEvent(new MouseEvent('click'))
    },
    fileLoad () {
      const selectedFile = this.$refs.refFile.files[0]
      this.fileArr.push(selectedFile)
      const index = selectedFile.name.lastIndexOf('.')
      const strtype = selectedFile.name.substring(index)
      const size = selectedFile.size
      if (strtype !== '.txt') {
        this.failureMessage = 'You cannot import files of this type'
        this.dialog.failure = true
      } else if (size > 1048576) {
        this.failureMessage = 'Upload file size cannot exceed 1MB'
        this.dialog.failure = true
      } else {
        const $this = this
        $this.isLoading = true
        var input = $this.prepareParameter()
        input = JSON.stringify(input)
        const request = new FormData()
        request.append('file', $this.fileArr[0])
        request.append('leadFilterParameter', input)
        LFSConfigurationApi.importLeadFilterParameter(request, function (result) {
          $this.isLoading = false
          $this.dialog.inputSuccessful = true
          $this.successfulMessage = 'Total: ' + result.total + ', Success: ' + result.success + ', Duplicate: ' + result.duplicate
          $this.select_label = 'TOTAL ' + ($this.showFilter.count + result.success) + ' ITEMS'
          $this.fileArr = []
          document.getElementById('refFile').value = null
        }, function (result) {
          $this.isLoading = false
          $this.failureMessage = result.message
          $this.dialog.failure = true
        })
      }
    },
    exportFile () {
      const $this = this
      const input = $this.prepareParameter()
      LFSConfigurationApi.exportLeadFilterParameter(input, function (result) {
        $this.dialog.successful = true
        window.open(result)
      }, function () {
        $this.failureMessage = 'Failure'
        $this.dialog.failure = true
      })
    },
    prepareParameter () {
      return {
        companyId: 1,
        channelId: this.showFilter.channelId,
        portfolioId: this.showFilter.portfolioId,
        type: this.showFilter.type,
        sectionKey: this.showFilter.sectionKey,
        parameterKey: this.showFilter.parameterKey,
        operator: this.showFilter.operator
      }
    }
  },
  created () {
    this.select_state = this.states.find(e => e.value === this.showFilter.operator).text
    this.select_label = 'TOTAL ' + this.showFilter.count + ' ITEMS'
  }
}
</script>

<style scoped>
.filter-item {
  border: 1px solid #ccc;
  margin: 7px;
  display: inline-block;
  width: 48%;
}
.filter-item-header {
  background-color: #ddd;
  display: flex;
  justify-content: space-between;
}
.filter-item-content {
  background-color: #ddd;
  display: flex;
  justify-content: space-between;
  padding: 10px 3% 20px;
}
.operation-btn {
  margin-top: -2px;
}
.operation-btn-delete {
  margin-top: -2px;
  color: red;
}
.search-content {
  display: flex;
}
.select {
  padding: 0px;
  font-size: 16px;
  font-weight: bolder;
  vertical-align: -1px;
  display: inline-block;
  direction: rtl;
  outline: none;
  overflow : hidden;
  text-overflow : ellipsis;
  white-space : nowrap;
}
.tag {
  display: inline-block;
  width: 0;
  height: 0;
  vertical-align: .255em;
  content: "";
  border-top: .3em solid;
  border-right: .3em solid transparent;
  border-bottom: 0;
  border-left: .3em solid transparent;
  margin: 0 5px 0 2px;
}
.select option {
  color: #000;
  direction: ltr;
}
.state {
  padding: 6px;
  font-weight: bolder;
  font-size: 13px;
  width: 324px;
  overflow : hidden;
  text-overflow : ellipsis;
  white-space : nowrap;
}
.add-icons {
  color: #fff;
  width: 12%;
  height: 38px;
  line-height: 34px;
  font-size: 28px;
  border-radius: 20%;
  cursor: pointer;
  text-align: center;
}
.add-icons-delete {
  background-color: #FF3502;
  color: #fff;
  width: 12%;
  height: 38px;
  line-height: 34px;
  font-size: 48px;
  border-radius: 20%;
  cursor: pointer;
  text-align: center;
}
.items {
  height: 38px !important;
}
.total-items {
  background-color: #fff;
  height: 38px;
  width: 100%;
  padding: 5px;
  line-height: 30px;
  font-size: 16px;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
}
.contentItems {
  position: relative;
}
.searchItems {
  width: 84%;
  height: auto;
  border: none;
  box-shadow: 0 5px 30px 0 rgb(0 0 0 / 25%);
  background: #fff;
  color: #000;
  position: absolute;
  top: -20px;
  left: 0px;
  z-index: 1000;
  border-radius: 0 0 5px 5px;
  margin: 0 3% 0;
}
.content-input {
  -webkit-appearance: none;
  background-color: #fff;
  font-size: 14px;
  display: block;
  box-sizing: border-box;
  width: 96%;
  border: 1px solid rgba(0,0,0,.14);
  padding: 8px 13px;
  margin: 10px auto;
  border-radius: 2px;
  transition: border-color .2s;
}
.content-searching {
  -webkit-appearance: none;
  background-color: #fff;
  color: #bbb;
  border: none;
  font-size: 14px;
  display: block;
  box-sizing: border-box;
  width: 96%;
  height: 24px;
  padding: 0px 10px;
  margin: 10px auto;
  border-radius: 2px;
  transition: border-color .2s;
}
.item-tabs {
  list-style: none;
  background: white;
  text-align: left;
  padding: 0 10px;
}
.item-tabs li{
  background-color: #fff;
  height: 24px;
  font-size: 13px;
  line-height: 6px;
  padding: 10px;
  margin: 10px 0;
}
.item-tabs li:hover{
  background-color: #eee;
}
</style>
